<div class="main-content">
  <div class="container-fluid p-0">
    <div class="row">
      <div class="col-md-12">
        <span class="pull-left">
          <h2 class="text-purple-manax m-0 pl-3 title-section"><b>Clientes</b></h2>
        </span>
        <span class="pull-right pt-1 pb-4">
          <button mat-raised-button type="button" class="btn btn-manax p-2 mr-1" (click)="openNewClientModal()">
            <i class="material-icons">add</i>&nbsp;<span class="d-none d-sm-inline">Nuevo Cliente</span>
          </button>
          <button (click)="openHelpVideoModal()" class="btn btn-outline-manax p-2 mr-3">
            <i class="material-icons align-middle">play_circle</i>&nbsp;<span class="d-none d-sm-inline">Tutorial</span>
          </button>
        </span>
        <br><br>
        <!--div class="card"-->
        <!--div class="card-header card-header-lavuro">
            <span class="pull-left">
              <h4 class="card-title ">Clientes</h4>
              <p class="card-category">Listado de clientes de la empresa</p>
            </span>
            <span class="pull-right">
              <button (click)="openHelpVideoModal()" class="btn btn-lavuro p-2 mr-1">
                <i class="material-icons align-middle">play_circle</i> Tutorial
              </button>
              <button mat-raised-button type="button" class="btn btn-lavuro p-2" (click)="openNewClientModal()">
                <i class="material-icons">add</i> Nuevo Cliente
              </button>
            </span>
          </div-->
        <!--div class="card-body">
            <div class="table-striped"-->
        <table class="table table-hover m-0 align-top" matSort (matSortChange)="sortClients($event)" stickyHeader
          stickyFooter>

          <thead class="text-manax pb-1">
            <tr>

              <!-- PC -->
              <th class="d-none d-md-table-cell p-0 pl-2">
                <div class="form-check m-0 mx-2">
                  <label class="form-check-label">
                    <input class="form-check-input input-sm" type="checkbox" (click)="toggleSelection()"
                      [checked]="selection.all">
                    <span class="form-check-sign">
                      <span class="check"></span>
                    </span>
                  </label>
                </div>
              </th>

              <!-- PC -->
              <th class="d-none d-md-table-cell align-top" style="height: 60px; position: relative;"
                mat-sort-header="clientType">
                Tipo<br>
              </th>
              <th class="d-none d-md-table-cell align-top" style="height: 60px; position: relative;"
                mat-sort-header="firstname">
                Nombre<br>
                <input type="text" class="filter small" [(ngModel)]="filter.filters.firstname"
                  placeholder="Buscar por nombre…" (ngModelChange)="lazySearch()" (click)="$event.stopPropagation()"
                  (keydown.space)="$event.stopPropagation()"
                  style="max-width: 1000px; position: absolute; top: 27px; left: 0px;" />
              </th>
              <th class="d-none d-md-table-cell align-top" style="height: 60px; position: relative;"
                mat-sort-header="lastname">
                Apellido<br>
                <input type="text" class="filter small" [(ngModel)]="filter.filters.lastname"
                  placeholder="Buscar por apellido…" (ngModelChange)="lazySearch()" (click)="$event.stopPropagation()"
                  (keydown.space)="$event.stopPropagation()"
                  style="max-width: 1000px; position: absolute; top: 27px; left: 0px;" />
              </th>
              <th class="d-none d-md-table-cell align-top" style="height: 60px; position: relative;"
                mat-sort-header="nit">
                Denominación Social<br>
              </th>
              <!--th class="d-none d-md-table-cell align-top" style="height: 60px; position: relative;"
                      mat-sort-header="phone">
                      Telefonos<br>
                    </th>
                    <th class="d-none d-md-table-cell align-top" style="height: 60px; position: relative;"
                      mat-sort-header="dob">
                      Emails<br>
                    </th>
                    <th class="d-none d-md-table-cell align-top" style="height: 60px; position: relative;"
                      mat-sort-header="dob">
                      Direcciones<br>
                    </th>
                    <th class="d-none d-md-table-cell align-top" style="height: 60px; position: relative;"
                      mat-sort-header="nit">
                      Nro. Id. Fiscal<br>
                    </th-->
              <th class="d-none d-md-table-cell align-top" width="1%"
                style="height: 65px; position: relative; max-width: 1000px;" mat-sort-header="isDeleted">
                Estado<br>
                <select class="filter small" [(ngModel)]="filter.filters.isDeleted" (ngModelChange)="lazySearch()"
                  (click)="$event.stopPropagation()"
                  style="max-width: 1000px; position: absolute; top: 27px; left: 0px;">
                  <option [ngValue]="false"> activo </option> <!-- isDeleted: false -->
                  <option [ngValue]="true"> inactivo </option> <!-- isDeleted: true -->
                  <option [ngValue]="undefined"> todos </option>
                </select>
              </th>

              <!-- Mobile -->
              <!-- <th class="d-table-cell d-md-none">
                Orden por: <span class="ml-2">{{sortOptions[filter.sort] || 'ninguno'}}</span>
                <span class="text-lavuro pull-right cursor-pointer" *ngIf="filtered"> - Filtrada - </span>
              </th> -->

              <!-- PC -->
              <th class="d-none d-md-table-cell td-actions text-right p-0">
                <button mat-icon-button type="button" class="btn btn-default btn-link btn-just-icon"
                  [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()">
                  <i class="material-icons">more_vert</i>
                </button>
                <mat-menu #menu="matMenu">

                  <!-- sort order -->
                  <button mat-menu-item class="d-block d-md-none" [matMenuTriggerFor]="order">
                    <span>Orden</span>
                  </button>

                  <!-- filters -->
                  <!--button mat-menu-item class="d-block d-md-none" (click)="openFilter()">
                          <span>Filtros</span>
                        </button-->
                  <button mat-menu-item (click)="clearFilter()">
                    <span>Limpiar Filtros</span>
                  </button>
                </mat-menu>

                <mat-menu #order="matMenu">
                  <ng-container *ngFor="let key of sortOptionsKeys">
                    <button mat-menu-item (click)="sortClients(key)">
                      <span>{{sortOptions[key]}}</span>
                    </button>
                  </ng-container>
                  <button mat-menu-item (click)="sortClients('')">
                    <span>Sin Ordenar</span>
                  </button>
                </mat-menu>
              </th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let client of clients" [class.text-danger]="client.isDeleted" class='cursor-pointer'
              (click)="openClientModal(client, true)">

              <!-- All -->
              <td class="d-none d-md-table-cell p-0 pl-2" (click)="$event.stopPropagation();">
                <div class="form-check m-0 mx-2">
                  <label class="form-check-label">
                    <input class="form-check-input input-sm" type="checkbox" (click)="toggleSelection(client._id)"
                      [checked]="selection.all || selection[client._id || '']">
                    <span class="form-check-sign">
                      <span class="check"></span>
                    </span>
                  </label>
                </div>
              </td>

              <!-- PC -->
              <td class="d-none d-md-table-cell">{{clienTypes[client.clientType || ''] || clienTypes.PERSON}}</td>
              <td class="d-none d-md-table-cell">{{client.firstname}}</td>
              <td class="d-none d-md-table-cell">{{client.lastname}}</td>
              <td class="d-none d-md-table-cell">{{client.corporatename}}</td>
              <!--td class="d-none d-md-table-cell">
                      <span *ngFor="let phone of client.phones">{{phone.number}} <br></span>
                    </td>
                    <td class="d-none d-md-table-cell">
                      <span *ngFor="let email of client.emails">{{email.address}} <br></span>
                    </td>
                    <td class="d-none d-md-table-cell">
                      <span *ngFor="let address of client.addresses">{{address.address}}
                        <br></span>
                    </td>
                    <td class="d-none d-md-table-cell">{{client.nit}}</td-->
              <td class="d-none d-md-table-cell">
                <span *ngIf="!client.isDeleted">activo</span>
                <span *ngIf="client.isDeleted">inactivo</span>
              </td>

              <!-- Mobile -->
              <td class="d-table-cell d-md-none" style="line-height: 14px;">
                <div class="col-12">
                  <div class="row">
                    <div class="col-12">
                      <div class="row mb-2 pr-3">
                        <b class="bold-item">
                          {{client.firstname}} {{client.lastname}}
                        </b>
                      </div>
                      <div class="row mb-2 pr-3">
                        Tipo: {{clienTypes[client.clientType || ''] || clienTypes.PERSON}}
                      </div>
                      <div class="row pr-3" *ngIf="client.addresses && client.addresses[0]">
                        {{client.addresses[0].address}}
                      </div>
                    </div>
                  </div>
                </div>
              </td>

              <!-- All -->
              <td class="td-actions text-right p-0">
                <button mat-icon-button type="button" class="btn btn-default btn-link btn-just-icon"
                  [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()">
                  <i class="material-icons">more_vert</i>
                </button>
                <mat-menu #menu="matMenu">
                  <button mat-menu-item (click)="openClientModal(client, true)">
                    <span>Abrir</span>
                  </button>
                  <button mat-menu-item (click)="openClientModal(client)">
                    <span>Modificar</span>
                  </button>
                  <button mat-menu-item (click)="openExternalRequestModal(client)">
                    <span>Compartir Información</span>
                  </button>
                  <button mat-menu-item (click)="openDeleteClientConfirm(client, true)" *ngIf="isDev">
                    <span>Hard Delete</span>
                  </button>
                  <button mat-menu-item (click)="openDeleteClientConfirm(client)" *ngIf="!client.isDeleted">
                    <span>Eliminar</span>
                  </button>
                  <button mat-menu-item (click)="openRestoreClientConfirm(client)" *ngIf="client.isDeleted">
                    <span>Restaurar</span>
                  </button>
                </mat-menu>
              </td>
            </tr>

            <!-- All  -->
            <tr *ngIf="thereAreMore && !loading">
              <td colspan="10">
                <button class="btn btn-link text-purple-manax text-capitalize p-0" (click)='loadMore()'>+ cargar
                  mas</button>
              </td>
            </tr>
            <tr *ngIf="loading">
              <td colspan="10" class="text-center">
                <div class="d-flex justify-content-center" >
                  <div class="spinner-border" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
          <tfoot class="text-purple-manax" *ngIf="!loading">
            <tr >
              <td colspan="10" class="text-left p-0 py-2 pl-3">Mostrando: {{ clients.length }} clientes</td>
            </tr>
          </tfoot>
        </table>
        <!--/div>
          </div>
        </div-->
        <div class="row" *ngIf="totalMoreMinTutorial && !loading">
          <div class="col-12 video-responsive">
            <iframe [src]="safeSrc" title="YouTube video player" frameborder="0"
              allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowfullscreen></iframe>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>